module.exports = __webpack_public_path__ + "img/no_robot.5a4e5cc1.png";